$(document).ready(function () {
  setTimeout(function () {
    var announcementHeight = $(".announcement-bar").outerHeight() || 0;
    var headerHeight = $("#shopify-section-header").outerHeight() || 0;
    var totalHeight = announcementHeight + headerHeight - 10;

    $("#MainContent").css("padding-top", totalHeight + "px");
  }, 1000);
  // Set initial padding after 1.5 seconds
  setTimeout(function () {
    var topMainHeadHeight = $(".top-main-head").height() || 0;
    var announcementBarHeight = $(".announcement-bar").height() || 0;
    var totalHeight = topMainHeadHeight + announcementBarHeight;
    $(".main-content").css("padding-top", totalHeight);
  }, 1500);

  // Update padding on scroll
  $(window).on("scroll", function () {
    var topMainHeadHeight = $(".top-main-head").height() || 0;
    var announcementBarHeight = $(".announcement-bar").height() || 0;
    var totalHeight = topMainHeadHeight + announcementBarHeight;
    $(".main-content").css("padding-top", totalHeight);
  });

  $(".happy-customer")
    .find(".quote-text")
    .hover(function () {
      $(this).context.scrollHeight > $(this).context.clientHeight &&
      !$(this).hasClass("showContent")
        ? $(this).addClass("showContent", 900)
        : $(this).hasClass("showContent") &&
          $(this).removeClass("showContent", 900);
    }),
    $(".okeReviews-reviewsSummary-ratingCountss > span:first").each(
      function () {
        var t = $(this).text();
        (t = t.replace(" Reviews", "")), $(this).text("(" + t + ")");
      }
    );
});

$(document).ready(function () {
  function Custom_header_Height() {
    var header_Height = $("div#shopify-section-header").outerHeight();
    console.log(header_Height);
    $("#MainContent").css("padding-top", header_Height);
  }
  Custom_header_Height();
  $(window).on("resize", function (evt) {
    Custom_header_Height();
  });



});